import React, { useState, useRef } from 'react';

/**
 * Компонент тултипа с расширенным содержимым
 * @param {Object} props - Свойства компонента
 * @param {string} props.content - Заголовок тултипа
 * @param {React.ReactNode} props.children - Содержимое ячейки таблицы
 * @param {Array|string} props.originalMessages - Сообщения об ошибках для отображения в тултипе
 */
const CustomTooltip = ({ content, children, originalMessages }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  return (
    <th 
      ref={ref}
      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider relative"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && originalMessages && (
        <div 
          className="absolute z-[100] top-full left-1/2 transform -translate-x-1/2 px-3 py-2 mt-2 bg-black text-white text-sm rounded-md shadow-lg"
          style={{ pointerEvents: 'none', maxWidth: '500px', minWidth: '200px' }}
        >
          <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-black rotate-45"></div>
          <div className="font-bold mb-2">{content}</div>
          <div className="text-xs text-gray-300">
            <div className="font-semibold mb-1">Errors included:</div>
            <ul className="list-disc list-inside space-y-1 max-h-48 overflow-y-auto">
              {Array.isArray(originalMessages) ? 
                originalMessages.map((message, index) => (
                  <li key={index} className="break-all">{message}</li>
                )) : 
                <li>{originalMessages}</li>
              }
            </ul>
          </div>
        </div>
      )}
    </th>
  );
};

export default CustomTooltip;